<div class="row mt-2">
  <div class="col-lg-3 col-md-6 col-6 mt-3 mb-0 px-2" *ngFor="let pastClientCard of pastClientCardList" (click)="getCardValue(pastClientCard)">
    <div class="dash_card" [class.active]="selectedKeys == pastClientCard.key"
    (click)="selectCard(pastClientCard.key)">
      <div>
        <h6 class="">{{ pastClientCard.heading }}</h6>
        <h5 class="display-4 mb-0">{{ pastClientCard.value }}</h5>
        <div class="favBalance">
          <div class="btn_sml pt-2" style="cursor: pointer">{{ pastClientCard.text }}</div>
        </div>
      </div>

      <div class="bg_efx"></div>
    </div>
  </div>
</div>

<div class="dash_card mt-3">
  <div class="row">
    <div class="col-md-12 col-sm-12 col-12">
      <div class="flex_center w-100" *ngIf="!checkFeatureAccess('pastClients')">
        <div class="notFound text-center noData">
          <div>
            <img class="img-fluid" width="60" src="~/../assets/images/notFound.svg" />
            <h4>Past clients is not enabled for the selected plan</h4>
          </div>
        </div>
      </div>

      <app-past-clients-list
        *ngIf="checkFeatureAccess('pastClients')"
        [isLtv] = "isLTV" 
        [isLongTerm] = "isLongTerm"
        [displayedColumns]="[
          'transactionType',
          'clientName',
          'currentOwner',
          'transactionDate',
          'address',
          'occupancy',
          'currentStatus',
          'currentValue',
          'equity',
          'ltv',
          'ownedFor',
          'action'
        ]"
     (reset)="resetFilter($event)" ></app-past-clients-list>

      <div style="width: 100%; max-width: 1000px; height: 400px" *ngIf="pastClientInfo?.data?.length > 0">
        <highcharts-chart
          [Highcharts]="Highcharts"
          [options]="chartOptions"
          [oneToOne]="true"
          style="display: block; width: 100%; height: 100%"
        ></highcharts-chart>
      </div>
    </div>
  </div>
</div>
<app-create-mail-sheet *ngIf="openCreateMailSheetValue"></app-create-mail-sheet>
<app-add-contact-note-sheet *ngIf="openAddContactNoteSheetValue"></app-add-contact-note-sheet>
